import CommonGround from "../assets/projects/commonground.png";
import Brainflix from "../assets/projects/brainflix.png";
import Instock from "../assets/projects/instock.png";

export const data = [
  {
    id: 1,
    name: "Common Ground Chat",
    image: CommonGround,
    github: "https://github.com/gjjrpin/common-ground",
    live: "https://commonground.chat/",
    technologies: "HTML JS",
    description: "A chat that pairs two people to discuss and debate divisive topics.",
  },
  {
    id: 2,
    name: "Instock Group Project",
    image: Instock,
    github: "https://github.com/gjjrpin/instock-server",
    live: "",
    technologies: "HTML JS",
    description:
      "A full-stack group project inventory manager built at Brainstation.",
  },
  {
    id: 3,
    name: "Brainflix",
    image: Brainflix,
    github: "https://github.com/gjjrpin/GJ-Pineda-brainflix",
    live: "",
    technologies: "HTML JS",
    description:
      "A front-end YouTube clone for video streaming and interactive engagement.",
  },
];
